export class CommentPopupWindow extends HTMLElement {
    template = `
			<style>
				.popup-overlay {
					background: #aaa;
					opacity: .4;
					position: fixed;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					z-index: 100;
				}
				
				.popup-window-container {
					position: absolute;
					z-index: 101;
					width: 300px;
					height: auto;
					font-size: 12px;
					
				}
				
				.title-row {
					box-sizing: border-box;
					background-image: linear-gradient(to bottom, #4A6C84 15%, #395364 85%);
					background-color: #395364;
					color: white;
					border: none;
					position: relative;
					width: 100%;
					min-width: 100%;
					padding: 4px 4px 2px 10px;
					white-space: nowrap;
					overflow: hidden;
    				text-overflow: ellipsis;
				}
				
				.title {
					display: inline-block;
					width: 90%;
					min-width: 90%;
				}
				
				.close-icon-container {
					display: inline-block;
					width: 12px;
					min-width: 12px;
					height: 12px;
					min-height: 12px;
					float: right;
					padding: 2px;
					cursor: pointer;
				}
				
				.close-icon-container img {
					width: 100%;
					height: 100%;
				}
				
				.text {
					min-height: 100px;
					max-height: none;
					height: auto;
					background: #EFEFF7;;
					color: #333;
					border: medium solid #395364;
					padding: 0.5em 1em;
				}
			</style>
			<div class="popup-window-container">
				<div class="title-row">
					<div class="title"><!-- Title --></div>
					<div class="close-icon-container"><img src="/share/data/document/close_comment_2.gif" alt="Zavřít"></div>
					 
				</div>
				<div class="text"><!-- Full comment --></div>
			</div>
			
			<div class="popup-overlay"></div>
		`;

    static get observedAttributes() {
        return [ 'text', ];
    }

    private shadow: ShadowRoot;

    private overlay:             HTMLDivElement;
    private titleContainer:      HTMLDivElement;
    private textContainer:       HTMLDivElement;
    private closeIconContainer:  HTMLDivElement;

    constructor() {
        super();
        this.shadow = this.attachShadow({ mode: "open" });

        this.shadow.innerHTML   = this.template;

        this.overlay            = this.shadow.querySelector('.popup-overlay') as HTMLDivElement;
        this.titleContainer     = this.shadow.querySelector('.title') as HTMLDivElement;
        this.textContainer      = this.shadow.querySelector('.text') as HTMLDivElement;
        this.closeIconContainer = this.shadow.querySelector('.close-icon-container') as HTMLDivElement;

        this.overlay.addEventListener('click', () => this.remove());
        this.closeIconContainer.addEventListener('click', () => this.remove());
    }

    connectedCallback() {
        this.titleContainer.textContent = this.getAttribute('data-title');
        this.textContainer.textContent = this.getAttribute('data-text');
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        this.textContainer.textContent  = newValue;
    }

    moveNextTo(element: HTMLElement) {
        const rect = element.getBoundingClientRect();

        const popupWindowContainer = this.shadow.querySelector('.popup-window-container') as HTMLDivElement;
        popupWindowContainer.style.top = `${rect.top + window.scrollY}px`;
        popupWindowContainer.style.left = `${rect.left - 290}px`;
    }
}